<template>

  <RiepilogoMensileInsoluti />
 
</template>

<script>
import RiepilogoMensileInsoluti from '../components/pratiche/RiepilogoMensileInsoluti.vue'

export default {
  pageName: '',
  components: {
    RiepilogoMensileInsoluti

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
